// @ag-grid-community/react v27.3.0
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
let counter = 0;
function generateNewKey() {
    return `agPortalKey_${++counter}`;
}
exports.default = generateNewKey;

//# sourceMappingURL=keyGenerator.js.map
